import $ from 'jquery'
import 'jquery-migrate'
import './modules/_skip-link-focus-fix'
import './modules/_foundation-scripts'
import 'jquery-match-height/jquery.matchHeight.js'
import Cookies from 'js-cookie'

import 'slick-carousel/slick/slick.min'

import { detect } from 'detect-browser'

/**
 * Notes:
 *
 * Although jQuery is imported above, it is not bundled
 * with the transpiled assets. jQuery needs to be global
 * on the website.
 *
 * All imports belong at the top of the file.
 *
 * Webpack only outputs this one script file, if you need
 * another file then add it to the scripts-list.js file as
 * another line in the scripts_list object.
 *
 * The scripts_list const is imported into the webpack
 * config. I've done this so that you do not have to
 * wade through the config to find what is being
 * compiled out as its own file.
 *
 * When importing node modules that are not ES6 modules,
 * you do not need to path them as '../../node_modules/'.
 * Gulp knows about the node_modules directory, so all you need
 * to do is path them as if you were already in the node_modules
 * directory
 *
 * Instead of:
 * import '../../node_modules/jquery-migrate/dist/jquery-migrate';
 *
 * Use:
 * import 'jquery-migrate/dist/jquery-migrate';
 *
 */

/*************** Template part region toggle button ***************/
$('#theme_debug_regions').on('click', function (event) {
	event.preventDefault()

	$('.placeHolderPosition').slideToggle()
})

/*************** Browser Version ***************/
const browser = detect()
const browser_version = browser.version.split('.')
const browser_html_class = browser.name + '-' + browser_version[0]

$('html').addClass(browser_html_class)

/****************** Mobile Menu Toggles ******************/
$(document).ready(function () {
	// Open and close the mobile menu
	$('#mobile_menu_toggle, #close_main_menu').click(function (event) {
		event.preventDefault()

		$('#mobile_menu_main_container').toggleClass('main-menu-open')
	})

	// Create element to toggle sub menus of mobile menu
	var $subMobleMenuButton = '<a href="#" class="mobile-submenu-button" id="mobile-submenu-toggle">Toggle</a>'

	// Append sub menu toggle button
	$('#main_menu').find('li.menu-item-has-children > a').append($subMobleMenuButton)

	// Toggle click event for sub menu toggle
	$('.mobile-submenu-button').click(function (event) {
		event.preventDefault()

		$(this).parent('a').siblings('ul').slideToggle()
	})
})

/*************** Match Height ***************/
$('.match-height').matchHeight()

$('.title-height').matchHeight()

/*************** Footer Partner Logos ***************/
$(document).ready(function () {
	$('.partner-logos').slick({
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 4000,
		responsive: [
			{
				breakpoint: 1350,
				settings: {
					arrows: false,
				},
			},
			{
				breakpoint: 1060,
				settings: {
					arrows: false,
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 800,
				settings: {
					arrows: false,
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 640,
				settings: {
					arrows: false,
					slidesToShow: 1,
				},
			},
		],
	})

	$('.testimonial-slider').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 4000,
		adaptiveHeight: true,
	})
})

/*************** Alert Bar ***************/
$('#close-alert').on('click', function (event) {
	event.preventDefault()

	$('#alert-bar').slideUp().empty()

	if (!Cookies.get('alert-bar')) {
		Cookies.set('alert-bar', 'clicked', { expires: 7 })
	} else {
		Cookies.remove('alert-bar')
	}
})

if (Cookies.get('alert-bar')) {
	$('#alert-bar').css('display', 'none')
}
